var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcCloseWhite30Px = function SvgIcCloseWhite30Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m14.73 11.5 5.05-5.05a.75.75 0 0 0 0-1.058L18.607 4.22a.75.75 0 0 0-1.058 0l-5.05 5.05-5.049-5.05a.75.75 0 0 0-1.058 0L5.219 5.392a.75.75 0 0 0 0 1.059l5.05 5.05-5.05 5.048a.75.75 0 0 0 0 1.059l1.173 1.173a.75.75 0 0 0 1.059 0l5.049-5.05 5.049 5.05a.75.75 0 0 0 1.059 0l1.173-1.173a.75.75 0 0 0 0-1.059z"
  })));
};
export default SvgIcCloseWhite30Px;